import { combineReducers } from "redux";

import {
  documentsWithSearchConstants
} from "../../actions/documentsWithSearch/index";

import {
  detailsDocumentConstants
} from "../../actions/detailsDocument/index";

import {
  notesConstants
} from "../../actions/detailsDocument/notes";

function filters(state, { type, payload }) {
  // risolve code smell di sonar
  let defaultState =
    typeof state === "undefined"
      ? {
        status: { error: false, started: false, ended: false },
        /* listUncollapsed contiene la lista dei titoli non collassati questo permette
         * di mantenere espanso la voce anche dopo aver filtrato oppure cambiato pagina
         */
        listUncollapsed: []
      }
      : state;
  switch (type) {
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_START:
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SIMPLE_START:
    return {
      ...defaultState,
      status: { error: false, started: true, ended: false }
    };
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SUCCESS:
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SIMPLE_SUCCESS:
    let newFilter = payload.response.filters.map(obj => ({
      ...obj,
      collapsed: false
      /* Lasciare il codice commentato in caso si volesse tornare a tutte le voci collassate
        defaultState.listUncollapsed
          ? !defaultState.listUncollapsed.includes(obj.title)
          : true
        */
    }));

    return {
      ...defaultState,
      list: newFilter,
      status: { error: false, started: false, ended: true, reset: payload.reset }
    };
  case documentsWithSearchConstants.TOGGLE_FILTER:
    let cloneState = { ...defaultState };
    let changedFilter = cloneState.list[payload.index];
    changedFilter.collapsed = !changedFilter.collapsed;
    cloneState.listUncollapsed = cloneState.listUncollapsed
      ? cloneState.listUncollapsed
      : [];
    if (!changedFilter.collapsed) {
      cloneState.listUncollapsed.push(changedFilter.title);
      cloneState.listUncollapsed = cloneState.listUncollapsed.filter((
        val, idx, self
      ) => {
        return idx === self.indexOf(val);
      });
    } else {
      cloneState.listUncollapsed = cloneState.listUncollapsed.filter(function(item) {
        return item !== changedFilter.title;
      });
    }
    return cloneState;
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_ERROR:
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SIMPLE_ERROR:
    return {
      ...defaultState,
      status: { error: true, started: false, ended: false }
    };
  default:
    return defaultState;
  }
}

function results(state, { type, payload }) {
  // risolve code smell di sonar

  let defaultState =
    typeof state === "undefined"
      ? { status: { error: false, started: false, ended: false } }
      : state;
  switch (type) {
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_START:
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SIMPLE_START:
    return {
      list: state && payload.isAppend ? state.list : null,
      status: { error: false, started: true, ended: false }
    };
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SUCCESS:
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SIMPLE_SUCCESS:
    return {
      list:
          state && payload.isAppend
            ? state.list.concat(payload.response.results)
            : payload.response.results,
      status: { error: false, started: false, ended: true, reset: payload.reset }
    };
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_ERROR:
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SIMPLE_ERROR:
    return { status: { error: true, started: false, ended: false } };
  case documentsWithSearchConstants.CLEAR_DOCUMENTS_WITH_SEARCH:
    return {
      list: null,
      status: { error: false, started: false, ended: false }
    };
  case detailsDocumentConstants.SET_DOCUMENT_VISIBILITY_STUDIO_SUCCESS:
    let cloneMyList = { ...defaultState };
    if (!cloneMyList.list) return defaultState;
    const listObjToModify = cloneMyList.list.find(el => el.documentId === payload.documentID);

    listObjToModify.visibleByStudioOnly = payload.isVisibleByStudioOnly;
    return cloneMyList;
  case detailsDocumentConstants.REMOVE_DOCUMENTS_SUCCESS:
    let clonedList = { ...defaultState };
    if (!clonedList.list) return defaultState;
    clonedList.list = clonedList.list.filter(el => el.documentId !== payload.idDoc);
    return clonedList;
  case notesConstants.CREATE_NOTE_SUCCESS:
    let cloneList = { ...defaultState };
    if (!cloneList.list) return defaultState;
    let actualDoc = cloneList.list.find(el => {
      return el.documentId === payload.documentID;
    });
    if (actualDoc) actualDoc["notesCount"] = actualDoc.notesCount + 1;
    return cloneList;
  case notesConstants.DELETE_NOTE_SUCCESS:
    let newCloneList = { ...defaultState };
    if (!newCloneList.list) return defaultState;
    let newActualDoc = newCloneList.list.find(el => {
      return el.documentId === payload.documentID;
    });
    if (newActualDoc) {
      newActualDoc["notesCount"] = newActualDoc.notesCount
        ? newActualDoc.notesCount - 1
        : 0;
    }
    return newCloneList;
  case documentsWithSearchConstants.READ_OR_NOT:
    let preReadList = { ...defaultState };
    if (preReadList.list) {
      let readedList = preReadList.list.find(el => {
        return el.documentId === payload.documentID;
      });
      if (readedList) readedList.read = true;
    }
    return preReadList;
  default:
    return defaultState;
  }
}

function links(state, { type, payload }) {
  // risolve code smell di sonar
  let defaultState = typeof state === "undefined" ? null : state;

  if (
    type === documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SUCCESS ||
    type === documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SIMPLE_SUCCESS
  ) {
    return payload.response._links ? payload.response._links.self : null;
  } 
  return defaultState;
  
}

function firstLink(state, { type, payload }) {
  // risolve code smell di sonar
  let defaultState = typeof state === "undefined" ? null : state;

  if (
    type === documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SUCCESS ||
    type === documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SIMPLE_SUCCESS
  ) {
    return payload.firstLink;
  } 
  return defaultState;
  
}

function txtSearch(state, { type, payload }) {
  // risolve code smell di sonar
  let defaultState = typeof state === "undefined" ? "" : state;

  switch (type) {
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SUCCESS:
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SIMPLE_SUCCESS:
    return payload.txtSearch;
  case documentsWithSearchConstants.CHANGE_TEXT_FILTER:
    return payload.txtSearch;
  default:
    return defaultState;
  }
}

function currentLink(state, { type, payload }) {
  // risolve code smell di sonar
  let defaultState = typeof state === "undefined" ? null : state;

  if (
    type === documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SUCCESS ||
    type === documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SIMPLE_SUCCESS
  ) {
    return payload.currentLink;
  } 
  return defaultState;
  
}

function totalCount(state, { type, payload }) {
  // risolve code smell di sonar
  let defaultState = typeof state === "undefined" ? null : state;
  let totalCount = 0;
  switch (type) {
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SUCCESS:
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SIMPLE_SUCCESS:
    let macroCategories = payload.response.filters.find(el => el.title === "Macro Categoria");
    // eslint-disable-next-line array-callback-return
    if (macroCategories) {
      // senza controllo va in errore e il messaggio non viene correttamente visualizzato
      macroCategories.links.map(el => {
        totalCount = totalCount + el.count;
        return totalCount;
      });
    }

    return totalCount;
  case documentsWithSearchConstants.CLEAR_TOTAL_COUNT:
  case documentsWithSearchConstants.CLEAR_DOCUMENTS_WITH_SEARCH:
    return 0;
  default:
    return defaultState;
  }
}

function isGettingDocumentsWithSearch(state, { type }) {
  // risolve code smell di sonar
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_START:
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SIMPLE_START:
    return true;
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_ERROR:
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SUCCESS:
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SIMPLE_SUCCESS:
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SIMPLE_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function getDocumentsSimple(state, { type }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SIMPLE_START:
    return {
      status: { error: false, started: true, ended: false }
    };
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SIMPLE_ERROR:
    return {
      status: { error: true, started: false, ended: false }
    };
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SIMPLE_SUCCESS:
    return {
      status: { error: false, started: false, ended: true }
    };
  default:
    return defaultState;
  }
}

function linkedDocumentsData(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case documentsWithSearchConstants.GET_LINKED_DOCUMENTS_START:
    return {
      status: { error: false, started: true, ended: false }
    };
  case documentsWithSearchConstants.GET_LINKED_DOCUMENTS_ERROR:
    return {
      status: { error: true, started: false, ended: false }
    };
  case documentsWithSearchConstants.GET_LINKED_DOCUMENTS_SUCCESS:
    return {
      status: { error: false, started: false, ended: true },
      linkedDocuments: payload.linkedDocumentsData.linkedDocuments
    };
  default:
    return defaultState;
  }
}
function companyWorkspaceId(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;

  switch (type) {
  case documentsWithSearchConstants.GET_WORKSPACEID_ERROR:
    return {
      status: { error: true, started: false, ended: false }
    };
  case documentsWithSearchConstants.GET_WORKSPACEID_SUCCESS:
    return {
      ...defaultState,
      status: { error: false, started: false, ended: true },
      companies: payload.response};
  default:
    return defaultState;
  }
}
function docsWidgetData(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;

  switch (type) {
  case documentsWithSearchConstants.GET_DOCS_WIDGET_ERROR:
    return {
      status: { error: true, started: false, ended: false }
    };
  case documentsWithSearchConstants.GET_DOCS_WIDGET_SUCCESS:
    return {
      ...defaultState,
      status: { error: false, started: false, ended: true },
      docsWidget: {
        aggregationValue: payload.response.aggregationValue,
        totalCount: payload.response.totalCount
      }
    };
  default:
    return defaultState;
  }
}

export const documentsWithSearch = combineReducers({
  filters,
  results,
  links,
  firstLink,
  txtSearch,
  currentLink,
  totalCount,
  isGettingDocumentsWithSearch,
  getDocumentsSimple,
  linkedDocumentsData,
  companyWorkspaceId,
  docsWidgetData
});

export default documentsWithSearch;
